var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.chooseEditorFor(_vm.value),{tag:"component",class:[
    _vm.value.type,
    {
      reader: !_vm.value.by_me,
      writer: _vm.value.by_me,
      patient: _vm.value.by.actsAsPatient,
      therapist: _vm.value.by.actAsTherapist,
    } ],attrs:{"value":_vm.value,"no-load":_vm.noLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }